import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';
import { useCarrier } from '../context/CarrierContext';

const CARRIERS = [
  { id: 'interfreight', label: 'Interfreight Transport LLC' },
  { id: 'fam', label: 'Fam Transport LLC' },
];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { carrierId, setCarrierId } = useCarrier();

  const isOnControlPanel = location.pathname === '/control-panel';

  const handleIconClick = () => {
    navigate(isOnControlPanel ? '/' : '/control-panel');
  };

  const handleCarrierChange = (event) => {
    setCarrierId(event.target.value);
  };

  return (
    <AppBar position="static" color="primary">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" sx={{ mr: 2 }}>
            InvoiceGen:
          </Typography>
          <Select
            value={carrierId}
            onChange={handleCarrierChange}
            size="small"
            sx={{ color: 'white', borderColor: 'white', '.MuiSvgIcon-root': { color: 'white' } }}
          >
            {CARRIERS.map((carrier) => (
              <MenuItem key={carrier.id} value={carrier.id}>
                {carrier.label}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <IconButton color="inherit" onClick={handleIconClick}>
          {isOnControlPanel ? <HomeIcon /> : <SettingsIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
